export const THEME_PRIMARY_MAIN_COLOR = "#709d4b";
export const THEME_PRIMARY_TEXT_COLOR = "#ffffff";

export const SELECTED_BLUE_COLOR = "#2196f3";
